module.exports = __webpack_public_path__ + "resources/img/img_text_to_speech2_en.9efe408e9520505dd02acfa5f19df8ca.png";